import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../auth/authContext";

const ProtectedRoute = ({ children }) => {
  const authContext = useContext(AuthContext);
  const location = useLocation();

  // 等待 AuthContext 初始化完成
  if (authContext === undefined || !authContext.isInitialized) {
    // 可以显示 loading 组件或者其他内容
    return <div>Loading...</div>;
  }

  if (!authContext || !authContext.user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (authContext.user.needUpdatePassword) {
    return <Navigate to="/change-password" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
